webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_game__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statistics__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_statistics__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_index___default.a
  }, {
    path: '/game',
    name: 'Game',
    component: __WEBPACK_IMPORTED_MODULE_3__components_game___default.a
  }, {
    path: '/statistics',
    name: 'Statistics',
    component: __WEBPACK_IMPORTED_MODULE_5__components_statistics___default.a
  }, {
    path: '/analytics',
    name: 'Analytics',
    component: __WEBPACK_IMPORTED_MODULE_4__components_analytics___default.a
  }]
}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(48),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    clusters: __webpack_require__(40)
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var $ = __webpack_require__(1);

var HDATA_BASE = 'https://vknko-165508.appspot.com';
var HDATA_RES = HDATA_BASE + '/result';
var HDATA_SOURCE = HDATA_BASE + '/candidate';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      candidate: undefined,
      count: 0
    };
  },
  created: function created() {
    this.loadNextCandidate();
  },

  components: {
    buttons: __webpack_require__(39),
    nko: __webpack_require__(42),
    vk: __webpack_require__(45),
    loading: __webpack_require__(41),
    sep: __webpack_require__(43)
  },
  methods: {
    onOk: function onOk() {
      this.sendResult(true);
      this.loadNextCandidate();
    },
    onNeok: function onNeok() {
      this.sendResult(false);
      this.loadNextCandidate();
    },
    sendResult: function sendResult(result) {
      $.post(HDATA_RES, {
        id: this.candidate.id,
        result: result
      });
    },
    loadNextCandidate: function loadNextCandidate() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.count++;

      var self = this;
      $.getJSON(HDATA_SOURCE, function (data) {
        self.loading = false;
        self.candidate = data;
      });
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['locked'],
  methods: {
    onNo: function onNo() {
      if (this.locked) {
        return;
      }
      this.$emit('neok');
    },
    onYes: function onYes() {
      if (this.locked) {
        return;
      }
      this.$emit('ok');
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var render = __webpack_require__(17).default;
var $ = __webpack_require__(1);
var _ = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      npo: undefined
    };
  },
  mounted: function mounted() {
    var _this = this;

    var width = $(this.$el).find('svg').width();
    var height = $(this.$el).find('svg').height();
    var svg = d3.select(this.$el).select('svg');
    $.getJSON('static/data/clusters.json', function (data) {
      render(svg, width, height, _.take(data.payload, 300), _this.onIn.bind(_this), _this.onOut.bind(_this));
    });
  },
  methods: {
    onIn: function onIn(d) {
      this.npo = d;
      console.log(d);
    },
    onOut: function onOut(d) {
      this.npo = undefined;
    }
  },
  components: {
    tooltip: __webpack_require__(44)
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item']
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {



module.exports = {
  name: 'tooltip',
  props: ['title', 'description']
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item']
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var $ = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: undefined,
      total: 0
    };
  },
  created: function created() {
    var _this = this;

    $.getJSON('https://vknko-165508.appspot.com/results', function (data) {
      _this.list = [];
      var left = 0;
      var right = 0;
      for (var j in data) {
        var e = data[j];
        e.id = j;
        _this.list.push(e);
        left += e.against;
        right += e.for;
      }
      _this.total = right / (left + right);

      _this.total = (_this.total * 100 + '').substr(0, 5) + '%';
      console.log(_this.list);
    });
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var d3 = __webpack_require__(21);
var _ = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = (function (svg, width, height, data, onIn, onOut) {

  var padding = 1.5,
      clusterPadding = 6,
      maxRadius = 12;

  var m = data.length;
  var color = d3.scale.category10().domain(d3.range(m));

  var clusters = new Array(m);
  var nodes = [];
  var n = 0;

  for (var i = 0; i < data.length; i++) {
    var els = data[i].els;
    n += els.length;
    for (var j = 0; j < els.length; j++) {
      var d = {
        cluster: i, radius: 2,
        name: els[j]
      };
      nodes.push(d);
      if (!clusters[i]) {
        clusters[i] = d;
      }
    }
  }

  var force = d3.layout.force().nodes(nodes).size([width, height]).gravity(.02).charge(0).on("tick", tick).start();

  svg.attr("width", width).attr("height", height);

  var circle = svg.selectAll("circle").data(nodes).enter().append("circle").attr("r", function (d) {
    return d.radius;
  }).style("fill", function (d) {
    return color(d.cluster);
  }).call(force.drag);

  function tick(e) {
    circle.each(cluster(10 * e.alpha * e.alpha)).each(collide(.5)).attr("cx", function (d) {
      return d.x;
    }).attr("cy", function (d) {
      return d.y;
    }).on('mouseover', function (d) {
      onIn(d);
    }).on('mouseout', function (d) {
      onOut(d);
    });
  }

  function cluster(alpha) {
    return function (d) {
      var cluster = clusters[d.cluster];
      if (cluster === d) return;
      var x = d.x - cluster.x,
          y = d.y - cluster.y,
          l = Math.sqrt(x * x + y * y),
          r = d.radius + cluster.radius;
      if (l != r) {
        l = (l - r) / l * alpha;
        d.x -= x *= l;
        d.y -= y *= l;
        cluster.x += x;
        cluster.y += y;
      }
    };
  }

  function collide(alpha) {
    var quadtree = d3.geom.quadtree(nodes);
    return function (d) {
      var r = d.radius + maxRadius + Math.max(padding, clusterPadding),
          nx1 = d.x - r,
          nx2 = d.x + r,
          ny1 = d.y - r,
          ny2 = d.y + r;
      quadtree.visit(function (quad, x1, y1, x2, y2) {
        if (quad.point && quad.point !== d) {
          var x = d.x - quad.point.x,
              y = d.y - quad.point.y,
              l = Math.sqrt(x * x + y * y),
              r = d.radius + quad.point.radius + (d.cluster === quad.point.cluster ? padding : clusterPadding);
          if (l < r) {
            l = (l - r) / l * alpha;
            d.x -= x *= l;
            d.y -= y *= l;
            quad.point.x += x;
            quad.point.y += y;
          }
        }
        return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
      });
    };
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  "data-v-d3dd9ca4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(24)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(49),
  /* scopeId */
  "data-v-2062c4fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-fa6ffe0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(52),
  /* scopeId */
  "data-v-4984e98c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(26)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(51),
  /* scopeId */
  "data-v-40093a3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(56),
  /* scopeId */
  "data-v-b8f49472",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  "data-v-84881546",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(55),
  /* scopeId */
  "data-v-87e7bd2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(50),
  /* scopeId */
  "data-v-39642de4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(53),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(47),
  /* scopeId */
  "data-v-0f79d5ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center jopa"
  }, [_c('b', [_vm._v(" Total: ")]), _vm._v(" " + _vm._s(_vm.total) + "\n  ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Stat")])])])
}]}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "dholder"
  }, [(_vm.loading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "some"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 cand-line"
  }, [_c('nko', {
    attrs: {
      "item": _vm.candidate.npo
    }
  })], 1), _vm._v(" "), _c('sep'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 cand-line"
  }, [_c('vk', {
    attrs: {
      "item": _vm.candidate.vk
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('buttons', {
    attrs: {
      "locked": _vm.loading
    },
    on: {
      "ok": _vm.onOk,
      "neok": _vm.onNeok
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tooltipPositioner"
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltip"
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltipContainer"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])])])])
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "500px",
      "override": "hidden"
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "450"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nah"
  }, [(_vm.npo) ? _c('tooltip', {
    attrs: {
      "title": _vm.npo.name,
      "description": " "
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5 col-xs-offset-1 col-md-4 col-md-offset-2"
  }, [_c('button', {
    class: _vm.locked ? 'btn btn-danger disabled' : 'btn btn-danger',
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onNo
    }
  }, [_c('span', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 col-md-4"
  }, [_c('button', {
    class: _vm.locked ? 'btn btn-success disabled' : 'btn btn-success',
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onYes
    }
  }, [_c('span', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row holder"
  }, [_c('div', {
    staticClass: "col-xs-6 col-xs-offset-1"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.item.name) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.url
    }
  }, [_vm._v(" " + _vm._s(_vm.item.url) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.item.description.substr(0, 120).replace(/<\/?[^>]+(>|$)/g, " ")) + "\n      "), (_vm.item.description.length > 120) ? _c('span', [_vm._v(" ... ")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.item.city) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.photo
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('h4', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.item.address) + " "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.item.region) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-offset-1"
  }, [_c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 text-center"
  }, [_vm._v("\n      -vs-\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "line"
  })])])])
}]}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center holder"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Loading\n  ")])])
}]}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Clusters")]), _vm._v(" "), _c('clusters')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Analytics")])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("NKO"), _c('br'), _vm._v(" Social Matcher")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-8 col-xs-offset-2"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/game"
    }
  }, [_vm._v("PLAY")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/statistics"
    }
  }, [_vm._v("\n        STATISTICS\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/analytics"
    }
  }, [_vm._v("\n        ANALYTICS (not mobile)\n      ")])])])])
}]}

/***/ })
],[18]);


// WEBPACK FOOTER //
// static/js/app.90d0ff142c2e04712c27.js